import React, { useState } from "react";

//UI Material
import {
  Alert,
  Button,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArrowBackIos,
  ArrowForwardIosTwoTone,
  Check,
} from "@mui/icons-material";

//Components
import ElcoLogo from "../Components/Logos/ElcoLogo";

//Helpers
import { hostPath } from "../Constants/constants";

export default function RecoverEmail() {
  // ==========>Component States<==========
  //State for setting the response message
  const [responseMessage, setResponseMessage] = useState("");
  //State for setting the response status
  const [responseStatus, setResponseStatus] = useState(false);
  //State for storing userEmail
  const [userEmail, setUserEmail] = useState("");
  //State for show the login loader
  const [isLoading, setIsLoading] = useState(false);

  // ==========>Component Functions<==========
  //Function to verify user email and send recover link
  const recoverEmailCredentials = async () => {
    setIsLoading(true);
    try {
      const requestedReponse = await fetch(
        hostPath + `/users/send-recovery-email`,
        {
          method: "POST",
          body: JSON.stringify({ userEmail }),
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      const jsonResponse = await requestedReponse.json();
      if (jsonResponse.status === "ok") {
        setResponseStatus(true);
        setResponseMessage(jsonResponse.description);
      } else {
        if (jsonResponse.description === "Error desconocido.") {
          setResponseMessage("Error de conexión, intente nuevamente más tarde");
        } else {
          setResponseMessage(jsonResponse.description);
        }
      }
    } catch (error) {
      setResponseMessage("Error de pepino, intente nuevamente más tarde");
    }
    setIsLoading(false);
  };

  //Function for generate recover email button status
  const selectButtonStatus = () => {
    if (isLoading) {
      return <CircularProgress />;
    } else {
      return (
        <Button
          variant="contained"
          color="secondary"
          endIcon={<ArrowForwardIosTwoTone />}
          sx={{ color: "white" }}
          onClick={recoverEmailCredentials}
        >
          {"Enviar código"}
        </Button>
      );
    }
  };

  //Function to display alert with response message
  const generateResponseMessageAlert = () => {
    if (
      responseMessage ===
      "Un correo fue enviado con la información para restablecer la contraseña."
    ) {
      return (
        <Grid item sx={{ marginTop: "10px", marginBottom: "10px" }}>
          <Alert severity="info">
            {responseMessage +
              " Este correo es válido sólo por una hora a partir de este momento."}
          </Alert>
        </Grid>
      );
    } else {
      return (
        <Grid item sx={{ marginTop: "10px", marginBottom: "10px" }}>
          <Alert severity="info">{responseMessage}</Alert>
        </Grid>
      );
    }
  };

  // ==========>Component<==========
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      textAlign="center"
      spacing={2}
      sx={{ p: 2, height: "90vh" }}
    >
      <Grid item xs={12}>
        <ElcoLogo height="50px" />
      </Grid>
      <Grid item xs={12}>
        <Typography fontWeight="bold" variant="h5">
          Recuperar Contraseña
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack justifyContent="center" alignItems="center" spacing={1}>
          <Typography>Correo Electrónico</Typography>
          <TextField
            value={userEmail}
            onChange={(e) => {
              setUserEmail(e.target.value.trim());
            }}
            inputProps={{ style: { textTransform: "lowercase" } }}
            placeholder="Ingrese su correo"
            color="secondary"
            sx={{ width: "275px" }}
          />
        </Stack>
      </Grid>

      {/**Text for response message*/}
      {responseMessage ? generateResponseMessageAlert() : null}
      <Grid item>
        <Button
          size="small"
          startIcon={<ArrowBackIos />}
          onClick={() => {
            window.history.back();
          }}
        >
          {"Volver"}
        </Button>
      </Grid>
      <Grid item>
        {responseStatus ? (
          <Button
            variant="disabled"
            color="secondary"
            endIcon={<Check />}
            sx={{ color: "white" }}
          >
            {"Código enviado"}
          </Button>
        ) : (
          selectButtonStatus()
        )}
      </Grid>
    </Grid>
  );
}
